// Máscaras de digitação. Guardamos sempre só os dígitos; a formatação existe
// para leitura e conferência enquanto a pessoa digita.

export function formatTelefone(valor) {
  const d = String(valor ?? "").replace(/\D/g, "").slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  // 8 dígitos (fixo) e 9 dígitos (celular) quebram em posições diferentes.
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

export function formatDocumento(valor, tipo = "PF") {
  const d = String(valor ?? "").replace(/\D/g, "").slice(0, tipo === "PJ" ? 14 : 11);
  if (tipo === "PJ") {
    return d
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2");
  }
  return d
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1-$2");
}

export const apenasDigitos = (valor) => String(valor ?? "").replace(/\D/g, "");

// Número CNJ no formato que o advogado lê: NNNNNNN-DD.AAAA.J.TT.OOOO.
//
// Estava escrito em dois componentes e faltando em todos os outros, então a
// mesma tela mostrava o número cru numa coluna e formatado noutra. Fica aqui
// para ser um só.
export function formatarCnj(valor) {
  const digitos = String(valor || "").replace(/\D/g, "");
  if (digitos.length !== 20) return valor || "";
  return digitos.replace(/^(\d{7})(\d{2})(\d{4})(\d)(\d{2})(\d{4})$/, "$1-$2.$3.$4.$5.$6");
}
